import { Download, FileText } from "lucide-react";

/**
 * Reusable CSV + PDF export button pair. Consumers pass a `getExport()`
 * callback that returns `{ filenameBase, meta, columns, rows }` on demand
 * so exports always reflect the currently-filtered data.
 */
export default function ExportButtons({ onCSV, onPDF, disabled = false, testIdPrefix = "export" }) {
  const base =
    "inline-flex items-center gap-1.5 px-3 py-1.5 bm-eyebrow border border-[#0a0a0a] hover:bg-[#0a0a0a] hover:text-[#f5f2eb] disabled:opacity-40 disabled:cursor-not-allowed";
  return (
    <div className="hidden md:flex items-center gap-2" data-testid={`${testIdPrefix}-group`}>
      <button
        type="button"
        onClick={onCSV}
        disabled={disabled}
        className={base}
        title="Download current view as CSV"
        data-testid={`${testIdPrefix}-csv`}
      >
        <Download size={12} /> CSV
      </button>
      <button
        type="button"
        onClick={onPDF}
        disabled={disabled}
        className={base}
        title="Download current view as PDF"
        data-testid={`${testIdPrefix}-pdf`}
      >
        <FileText size={12} /> PDF
      </button>
    </div>
  );
}
